import { NhostClientOptions } from '@nhost/nhost-js'

// Instance auto-hebergee (A+B) : en dehors du developpement local, toutes les
// URL derivent de l origine de la page. Le meme build sert n importe quel nom
// d hote pointe sur la pile ; la topologie (prefixes /v1/auth, /v1/storage,
// /v1/graphql, /api, /collab) est celle du docker-compose de la pile.
export const isLocal = location.hostname === 'localhost'
export const isStaging = false
export const isShareApp = /^\/share(\/|$)/.test(location.pathname)

const origin = isLocal ? 'http://localhost:5175' : location.origin
const wsOrigin = origin.replace(/^http/, 'ws')

export default {
  // Webapp url
  url: origin,

  // Website url (documentation publique de l editeur)
  websiteUrl: 'https://rolebase.io',

  // Nhost
  nhost: {
    // Le prefixe d auth DOIT finir par /v1 : nhost-js reconnait sa propre
    // requete de rafraichissement a `endsWith('/v1/token')`. Sinon elle
    // repasse par le rafraichissement sous un verrou deja tenu (Web Locks)
    // et le navigateur se bloque a chaque rafraichissement de jeton.
    authUrl: isLocal
      ? 'https://local.auth.local.nhost.run/v1'
      : `${origin}/auth/v1`,
    // nhost-js poste sur graphqlUrl TEL QUEL (chez Nhost, l ingress reecrit
    // /v1 en /v1/graphql) : ici on donne directement le chemin complet.
    graphqlUrl: isLocal
      ? 'https://local.graphql.local.nhost.run/v1'
      : `${origin}/v1/graphql`,
    storageUrl: isLocal
      ? 'https://local.storage.local.nhost.run/v1'
      : `${origin}/v1/storage`,
    functionsUrl: isLocal
      ? 'https://local.functions.local.nhost.run/v1'
      : `${origin}/api`,
    // Disable auto signin on share app
    autoSignIn: !isShareApp,
    autoRefreshToken: !isShareApp,
    clientStorageType: isShareApp ? 'cookie' : 'localStorage',
  } as NhostClientOptions,

  functionsUrl: isLocal
    ? 'https://local.functions.nhost.run/v1/'
    : `${origin}/api/`,

  backendUrl: isLocal ? 'http://localhost:8888' : `${origin}/api`,

  yjsCollab: {
    url: isLocal ? 'ws://localhost:1234' : `${wsOrigin}/collab`,
  },

  // Files
  memberPicture: {
    maxSize: 300, // in px
  },
  orgIcon: {
    maxSize: 256, // in px
  },

  // Services tiers de l editeur : desactives sur l instance auto-hebergee.
  // Une cle vide = fonctionnalite inerte (voir les gardes dans utils/).
  stripe: {
    publicKey: '',
  },

  crisp: {
    websiteId: '',
  },

  sentry: {
    dsn: '',
  },

  apps: {
    office365: {
      clientId: '',
    },
    googlecalendar: {
      clientId: '',
    },
  },
}
